import InfoIcon from "@assets/images/info.svg";
import warningIcon from "@assets/images/warning-red.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box } from "@mui/system";
import AdvancedTable from "@saleor/apps/components/AdvancedTable/AdvancedTable";
import MyTypography from "@saleor/components/MyTypography";
import classNames from "classnames";
import React from "react";

import useStyles from "./styles";
import usePMTResultsData from "./usePMTResultsData";

export default function SearchPMTlist({
  dataPmtSearch,
  hasError,
  handleAddToOrder,
  loading
}) {
  const classes = useStyles();
  const { columnsList, rowsData } = usePMTResultsData({
    row: dataPmtSearch
  });

  const isRowHold = row => row?.hold?.toLowerCase() === "hold";

  const handleAddItemToOrder = row => {
    if (row?.materialNo && !isRowHold(row)) {
      handleAddToOrder(row.materialNo);
    }
  };

  const handleRowStyle = row =>
    isRowHold(row) ? classes.cursorDefault : classes.cursorPointer;

  return (
    <>
      <MyTypography variant="subtitle1">ผลการค้นหา</MyTypography>
      <Box className={classNames(classes.ListWrapper, loading && "loading")}>
        {dataPmtSearch?.pmtMatSearch?.length > 0 ? (
          <AdvancedTable
            rootClassName={classes.MarginTop}
            cellAlign="center"
            headHeight={48}
            cellheight={48}
            columnsList={columnsList}
            rowsData={rowsData}
            maxHeight="45vh"
            loading={loading}
            onRowClick={row => handleAddItemToOrder(row)}
            dynamicRowStyle={row => handleRowStyle(row)}
          />
        ) : (
          <Box className={classes.info}>
            {hasError ? (
              <>
                <img
                  width={20}
                  src={warningIcon}
                  alt="warning"
                  className={classes.icon}
                />
                <MyTypography variant="body3" color="error" align={"center"}>
                  เกิดข้อผิดพลาดบางประการ กรุณาลองใหม่
                </MyTypography>
              </>
            ) : (
              <>
                <img
                  width={20}
                  src={InfoIcon}
                  alt="info"
                  className={classes.icon}
                />
                {loading ? (
                  <>
                    <MyTypography variant="body3" align={"center"}>
                      กำลังทำการค้นหา...
                    </MyTypography>
                    <CircularProgress />
                  </>
                ) : (
                  <MyTypography variant="body3" align={"center"}>
                    ยังไม่มีรายการ โปรดระบุข้อมูลและกดค้นหา
                  </MyTypography>
                )}
              </>
            )}
          </Box>
        )}
      </Box>
    </>
  );
}
